import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { LearningCenterManagementService } from '../../learning-center-management.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { Router } from '@angular/router';
import * as moment from 'moment';


@Component({
  selector: 'app-learning-center-preview',
  templateUrl: './learning-center-preview.component.html',
  styleUrls: ['./learning-center-preview.component.scss']
})
export class LearningCenterPreviewComponent implements OnInit {

  centerDetail: any;
  theme: any;
  title: string;
  formData: FormData;
  isEdit: boolean
  isLoading: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LearningCenterPreviewComponent>,
    private learningCenterManagementService: LearningCenterManagementService,
    public matDialog: MatDialog,
    private router: Router,
    private zone: NgZone
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.centerDetail = this.data.centerDetail;
      this.theme = this.data.theme;
      this.title = this.data.title;
      this.formData = this.data.formData;
      this.isEdit = this.data.isEdit
    }

  }

  onSubmit(viewStatus: boolean) {
    this.isLoading = true;
    const status = viewStatus ? '1' : '0'
    this.formData.append('VIEW_STATUS', status)
    if (this.isEdit) {
      this.learningCenterManagementService.updateLearningCenter(this.formData).subscribe(res => {
        if (res.success) {
          this.isLoading = false;
          this.callSuccessModal()
        }
      }, err => {
        console.log(err)
        alert('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
        this.isLoading = false;
      })
    } else {
      this.learningCenterManagementService.createLearningCenter(this.formData).subscribe(res => {
        if(res.success) {
          this.isLoading = false;
          this.callSuccessModal()
        }
      }, err => {
        console.log(err)
        alert('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
        this.isLoading = false;
      })
    }
  }

  callSuccessModal() {
    const successText = this.isEdit ? 'แก้ไขข้อมูลสำเร็จ' : 'สร้างศูนย์เรียนรู้สำเร็จ'
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.id = dialogConfig.id = 'modalConfirm' + moment().format('x');
      dialogConfig.width = '350px';
      dialogConfig.data = {
        title: 'สำเร็จ',
        description: '<img src="../../../assets/check.png" width="100px;" class="img-center">' + '<br>' + successText,
        cancleBtnText: 'ยืนยัน',
        customStyle: 'background-color: #58595B;'
      }

      const modal = this.matDialog.open(ModalComponent, dialogConfig);
      modal.afterClosed().subscribe(() => {
        this.matDialog.closeAll();
        this.zone.run(() => {
          this.router.navigate(['/learning-center-management']);
        });
      });
    }

  }
